import { render } from "./ResetPassword.vue?vue&type=template&id=42f69ecc&ts=true"
import script from "./ResetPassword.vue?vue&type=script&lang=ts"
export * from "./ResetPassword.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__